module.exports = __webpack_public_path__ + "24f43cc225f579217f6a8b139429ba05.svg";